import { render, staticRenderFns } from "./property-view-page.vue?vue&type=template&id=db5cdada&"
import script from "./property-view-page.vue?vue&type=script&lang=js&"
export * from "./property-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports